import React, { useEffect, useState } from 'react';
import { getEditorColor } from '../../util/ColorUtil';
import {
  getQuoteContainerClass,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';
import AuthorBlock, { getPublishDate } from './AuthorBlock';
import {useRouter} from "next/router";

const isItTemplate = () => {
  if (typeof document !== 'undefined') {
    return (
      document.querySelector('.gated_template') !== null ||
      document.querySelector('.non_gated_template') !== null ||
      document.querySelector('.solution_template') !== null ||
      document.querySelector('.media_template') !== null ||
      document.querySelector('.press_release') !== null ||
      document.querySelector('.case_study_dynamic') !== null ||
      document.querySelector('.freestyle_template_article') !== null);
  }
  return false;
};

const isItContentTemplateArticle = (pageType) => {
  if (typeof document !== 'undefined' && pageType) {
    return (
      pageType === 'Articles' &&
      document.querySelector('.content_template') !== null
    );
  }
  return false;
};

const TemplateText = ({
  children,
  color,
  itemCount,
  data,
  pageType,
  authorBlockData,
}) => {
  const emphasizedTextColor = getEditorColor(
    isItUndefined(children?.field_slug)
  )
    ? getEditorColor(isItUndefined(children?.field_slug))
    : getEditorColor(isItUndefined(children?.field_template_text));

  const [template, setTemplate] = useState(true);
  const [isContentTemplateArticle, setIsContentTemplateArticle] =
    useState(false);
  const [authorExists, setAuthorExists] = useState(false);
  const { locale } = useRouter();


  useEffect(() => {
    setTemplate(isItTemplate());
    setIsContentTemplateArticle(isItContentTemplateArticle(pageType));
    // setAuthorExists(children?.field_author?.length > 0);
    // setAuthorExists(authorBlockData != null);
    setAuthorExists(authorBlockData?.length > 0);
  }, [children]);

  const processContent = (htmlContent) => {
    if (!htmlContent) return [];
    if (typeof document === 'undefined') {
      return [];
    }

    if (authorExists) {
      return (
        <>
          {/*<AuthorBlock data={children?.field_author?.[0]?.author_block} />*/}
          <div className = "authors-wrapper">
            {authorBlockData.map((author, index) => (
              <AuthorBlock key={`author-${author?.field_author_name || 'author'}`} data={author} />
            ))}
          </div>
          {/*<AuthorBlock data={authorBlockData} />*/}
          <p dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </>
      );
    }
    return <p dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };

  const content = processContent(
    isItUndefined(children?.field_slug)
      ? children?.field_slug[0]?.value
      : cleanHTML(modifyLinks(isItUndefined(children?.field_template_text), locale))
  );

  const renderTemplateText = () => {
    return <div
        className={
          itemCount > 0
              ? `template-text text-template-items-item-${itemCount} ${authorExists ? 'author-content-block' : ''}`
              : `template-text ${authorExists ? 'author-content-block' : ''}`
        }
    >
      <span className={`${emphasizedTextColor ? emphasizedTextColor : ''}`}>
        {content}
      </span>
      {children?.field_template_quote[0]?.value &&
          renderChildren()
      }
    </div>
  }

  const renderChildren = () => {
    return (
        <div className={'quote'}>
          <div style={{ backgroundColor: color }} className={'quote-line'} />
          <span className={'text-quote'}>
            {children?.field_template_quote[0]?.value}
          </span>
          <div className={getQuoteContainerClass(children)}>
            {isItUndefined(children?.field_template_quote_name) && (
                <span className={'char'}></span>
            )}
            <div className={'sub-cont'}>
              <span className={'name'}>
                {children?.field_template_quote_name[0]?.value}{' '}
              </span>
              {isItUndefined(children?.field_template_quote_name) &&
                  isItUndefined(children?.field_template_quote_job) && (
                      <span>, </span>
                  )}
              <span className={'job'}>
                {children?.field_template_quote_job[0]?.value}
              </span>
            </div>
          </div>
        </div>
    )
  }


  return template || isContentTemplateArticle ? (
      isContentTemplateArticle ?
          <div className={"inner-container"}>
            {renderTemplateText()}
          </div>
          :
          renderTemplateText()
  ) : (
    <div
      style={{ padding: 0, paddingTop: 48 }}
      className={
        itemCount > 0
          ? `template-text text-template-items-item-${itemCount} ${authorExists ? 'author-content-block' : ''}`
          : `template-text ${authorExists ? 'author-content-block' : ''}`
      }
    >
      <div className={'inner-container'}>
        <span className={`${emphasizedTextColor ? emphasizedTextColor : ''}`}>
          {content}
        </span>
        {children?.field_template_quote[0]?.value && renderChildren()}
      </div>
    </div>
  );
};

export default TemplateText;
